import { render, staticRenderFns } from "./HomePage.vue?vue&type=template&id=f8225186&scoped=true"
import script from "./HomePage.vue?vue&type=script&lang=js"
export * from "./HomePage.vue?vue&type=script&lang=js"
import style0 from "./HomePage.vue?vue&type=style&index=0&id=f8225186&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8225186",
  null
  
)

export default component.exports